import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createBlock as _createBlock, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, resolveDynamicComponent as _resolveDynamicComponent, Fragment as _Fragment, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-95d39f9e"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "common-layout" }
const _hoisted_2 = { class: "contents" }
const _hoisted_3 = { class: "heaer-address" }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("a", { href: "/" }, "首页", -1))
const _hoisted_5 = { class: "top" }
const _hoisted_6 = { class: "above" }
const _hoisted_7 = ["src"]
const _hoisted_8 = ["src"]
const _hoisted_9 = { class: "right" }
const _hoisted_10 = { class: "share" }
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "iconfont" }, "", -1))
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "关注TA", -1))
const _hoisted_13 = [
  _hoisted_11,
  _hoisted_12
]
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { style: {"margin-left":"25px"} }, "已关注", -1))
const _hoisted_15 = [
  _hoisted_14
]
const _hoisted_16 = { class: "left" }
const _hoisted_17 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, "作品", -1))
const _hoisted_18 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "p1" }, null, -1))
const _hoisted_19 = { class: "centre" }
const _hoisted_20 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, "关注", -1))
const _hoisted_21 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "p1" }, null, -1))
const _hoisted_22 = { class: "fans" }
const _hoisted_23 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, "粉丝", -1))
const _hoisted_24 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "striping" }, null, -1))
const _hoisted_25 = {
  key: 0,
  class: "bottom"
}
const _hoisted_26 = {
  key: 1,
  class: "works"
}
const _hoisted_27 = { class: "son-box" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_home_head = _resolveComponent("home-head")!
  const _component_CurrentAddress = _resolveComponent("CurrentAddress")!
  const _component_el_header = _resolveComponent("el-header")!
  const _component_user_information = _resolveComponent("user-information")!
  const _component_firm_information = _resolveComponent("firm-information")!
  const _component_el_tab_pane = _resolveComponent("el-tab-pane")!
  const _component_el_tabs = _resolveComponent("el-tabs")!
  const _component_el_container = _resolveComponent("el-container")!
  const _component_html_footer = _resolveComponent("html-footer")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createVNode(_component_el_container, null, {
        default: _withCtx(() => [
          _createVNode(_component_el_header, null, {
            default: _withCtx(() => [
              _createVNode(_component_home_head),
              _createElementVNode("div", _hoisted_2, [
                _createElementVNode("div", _hoisted_3, [
                  _createVNode(_component_CurrentAddress, null, {
                    address: _withCtx(() => [
                      _hoisted_4,
                      _createTextVNode(" > 个人主页 ")
                    ]),
                    _: 1
                  })
                ])
              ])
            ]),
            _: 1
          }),
          _createVNode(_component_el_container, { class: "contents user-contents" }, {
            default: _withCtx(() => [
              _createElementVNode("div", _hoisted_5, [
                _createElementVNode("div", _hoisted_6, [
                  (_ctx.self)
                    ? (_openBlock(), _createElementBlock("img", {
                        key: 0,
                        src: _ctx.getImgUrl(_ctx.userinfot.portrait),
                        alt: "",
                        class: "phone"
                      }, null, 8, _hoisted_7))
                    : _createCommentVNode("", true),
                  (_ctx.self == false)
                    ? (_openBlock(), _createElementBlock("img", {
                        key: 1,
                        src: _ctx.getImgUrl(_ctx.getInformation.data.portrait),
                        alt: "",
                        class: "phone"
                      }, null, 8, _hoisted_8))
                    : _createCommentVNode("", true),
                  (_ctx.getInformation.data.company_id == null)
                    ? (_openBlock(), _createBlock(_component_user_information, {
                        key: 2,
                        onGetUserHome: _ctx.getUserHome,
                        getInformation: _ctx.getInformation.data
                      }, null, 8, ["onGetUserHome", "getInformation"]))
                    : _createCommentVNode("", true),
                  (_ctx.getInformation.data.company_id != null)
                    ? (_openBlock(), _createBlock(_component_firm_information, {
                        key: 3,
                        onGetUserHome: _ctx.getUserHome,
                        getInformation: _ctx.getInformation.data
                      }, null, 8, ["onGetUserHome", "getInformation"]))
                    : _createCommentVNode("", true),
                  _createElementVNode("div", _hoisted_9, [
                    _createElementVNode("div", _hoisted_10, [
                      (
                    _ctx.self == false &&
                    _ctx.getInformation.data.follow == 0 &&
                    _ctx.userinfor.data.pid == 0
                  )
                        ? (_openBlock(), _createElementBlock("div", {
                            key: 0,
                            class: "focus",
                            onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.dofollow(0)))
                          }, _hoisted_13))
                        : _createCommentVNode("", true)
                    ]),
                    (
                  _ctx.self == false &&
                  _ctx.getInformation.data.follow != 0 &&
                  _ctx.userinfor.data.pid == 0
                )
                      ? (_openBlock(), _createElementBlock("div", {
                          key: 0,
                          class: "focus1",
                          onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.dofollow(1)))
                        }, _hoisted_15))
                      : _createCommentVNode("", true),
                    _createElementVNode("div", {
                      class: _normalizeClass(["number", { numbers: _ctx.self == true }])
                    }, [
                      _createElementVNode("div", _hoisted_16, [
                        _createElementVNode("p", null, _toDisplayString(_ctx.getInformation.data.works), 1),
                        _hoisted_17
                      ]),
                      _hoisted_18,
                      _createElementVNode("div", _hoisted_19, [
                        _createElementVNode("p", null, _toDisplayString(_ctx.getInformation.data.follows), 1),
                        _hoisted_20
                      ]),
                      _hoisted_21,
                      _createElementVNode("div", _hoisted_22, [
                        _createElementVNode("p", null, _toDisplayString(_ctx.getInformation.data.fans), 1),
                        _hoisted_23
                      ])
                    ], 2)
                  ])
                ]),
                _hoisted_24,
                (_ctx.self)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_25, [
                      _createVNode(_component_el_tabs, {
                        modelValue: _ctx.activeName,
                        "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.activeName) = $event)),
                        class: "demo-tabs",
                        onTabClick: _ctx.handleClick
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_el_tab_pane, {
                            label: "作品",
                            name: "first"
                          }),
                          _createVNode(_component_el_tab_pane, {
                            label: "关注",
                            name: "second"
                          }),
                          _createVNode(_component_el_tab_pane, {
                            label: "粉丝",
                            name: "third"
                          })
                        ]),
                        _: 1
                      }, 8, ["modelValue", "onTabClick"])
                    ]))
                  : _createCommentVNode("", true),
                (_ctx.self == false)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_26, "TA的作品"))
                  : _createCommentVNode("", true)
              ])
            ]),
            _: 1
          })
        ]),
        _: 1
      }),
      _createElementVNode("div", _hoisted_27, [
        (_openBlock(), _createBlock(_resolveDynamicComponent(_ctx.tabs.show), { onTransmitData: _ctx.transmitData }, null, 40, ["onTransmitData"]))
      ])
    ]),
    _createVNode(_component_html_footer)
  ], 64))
}